import { ProviderInstanceModel } from './provider-instance-model';
import { ProviderInstanceResourceModel } from './provider-instance-resource-model';

export class ProviderInstanceCoupleCollectedModel {
  providerInstance: ProviderInstanceModel;
  providerInstanceResources: ProviderInstanceResourceModel[];
}
